import { RoomSnapshot } from '../room/types';

export function LobbyScreen({ snapshot }: { snapshot: RoomSnapshot }) {
  return (
    <div className="app fade-in">
      <div className="col">
        <div style={{ color: 'var(--c-text-muted)', fontSize: 28 }}>Room code</div>
        <div className="code">{snapshot.roomCode || '------'}</div>
      </div>

      <div style={{ fontSize: 28, color: 'var(--c-text-muted)', marginTop: 'var(--s-lg)' }}>
        Players ({snapshot.players.length})
      </div>

      <div className="row">
        {snapshot.players.map((p) => (
          <div className="player-card" key={p.playerId}>
            <div className="avatar" aria-hidden>👤</div>
            <div>
              <div style={{ fontSize: 22, fontWeight: 600 }}>{p.displayName}</div>
              <div style={{ fontSize: 16, color: 'var(--c-text-muted)' }}>
                {p.connected ? 'Connected' : 'Disconnected'}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="spacer" />

      <div style={{ fontSize: 22, color: 'var(--c-text-muted)' }}>
        Host: tap <strong>Start match</strong> on your phone when everyone's in.
      </div>
    </div>
  );
}
